import {AddPaymentMethodController} from '@wc-stripe/controllers';
import {getSetting} from '@wc-stripe/utils';
import Context from '@wc-stripe/context';
import {createCreditCardGateway} from '@wc-stripe/gateways'

const settings = getSetting('stripe_cc_data');

const context = new Context('add_payment_method');

const gateway = createCreditCardGateway(settings.cardFormType, {
    id: 'stripe_cc',
    settings,
    context
});

const controller = new AddPaymentMethodController({
    context,
    gateway,
    selector: gateway.selector
});

controller.initialize();